import React from 'react';
import { BookOutlined, CompassOutlined, FileTextOutlined, QuestionCircleOutlined, SafetyCertificateOutlined, TagsOutlined } from '@ant-design/icons';

interface Props {
  onAsk: () => void;
  onStartTour: () => void;
}

const HELP_LINKS = [
  {
    title: 'README',
    description: 'Overview, setup instructions, and core product workflows.',
    href: 'https://github.com/felpfeinc/Praxys.ai/blob/main/README.md',
    icon: <BookOutlined />,
  },
  {
    title: 'Quickstart Guide',
    description: 'Step-by-step instructions for running Praxys.ai locally.',
    href: 'https://github.com/felpfeinc/Praxys.ai/blob/main/QUICKSTART.md',
    icon: <BookOutlined />,
  },
  {
    title: 'API Examples',
    description: 'Reference examples for the main product APIs and services.',
    href: 'https://github.com/felpfeinc/Praxys.ai/blob/main/API_EXAMPLES.md',
    icon: <FileTextOutlined />,
  },
  {
    title: 'Release Notes',
    description: 'Recent releases and shipped changes for the repository.',
    href: 'https://github.com/felpfeinc/Praxys.ai/releases',
    icon: <TagsOutlined />,
  },
  {
    title: 'Terms of Service',
    description: 'Legal terms for using Praxys.ai.',
    href: 'https://praxys.ai/terms',
    icon: <FileTextOutlined />,
  },
  {
    title: 'Privacy Policy',
    description: 'Privacy and data handling information for Praxys.ai.',
    href: 'https://praxys.ai/privacy',
    icon: <SafetyCertificateOutlined />,
  },
];

const HelpView: React.FC<Props> = ({ onAsk, onStartTour }) => (
  <div className="praxys-view-panel">
    <div className="praxys-view-header">
      <BookOutlined className="praxys-view-icon" />
      <h2 className="praxys-view-title">Help</h2>
      <span className="praxys-view-subtitle">Product support and resources</span>
    </div>

    <div className="praxys-help-actions">
      <button type="button" onClick={onAsk}><QuestionCircleOutlined /> Ask Praxys Help</button>
      <button type="button" onClick={onStartTour}><CompassOutlined /> Tour this page</button>
    </div>

    <div className="praxys-help-grid">
      {HELP_LINKS.map(link => (
        <a
          key={link.title}
          href={link.href}
          target="_blank"
          rel="noreferrer"
          className="praxys-help-card"
        >
          <div className="praxys-help-card-icon">{link.icon}</div>
          <div className="praxys-help-card-copy">
            <h3>{link.title}</h3>
            <p>{link.description}</p>
          </div>
        </a>
      ))}
    </div>
  </div>
);

export default HelpView;
